import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppConfig } from 'src/app/shared/models/config-variable.model';


export const CONFIG_LOCATION:string = "assets/appsettings/config-variable.json";
export const APP_CONFIG: InjectionToken<AppConfig> = new InjectionToken<AppConfig>('APP_CONFIG');

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  
  private config$ = new BehaviorSubject<any>({});

  constructor(private http: HttpClient) {}

  // should be deprecated as the config is loaded with the fecth API in main.ts
  public load(): Observable<AppConfig> {
    return this.http
      .get<AppConfig>( CONFIG_LOCATION )
      .pipe(tap((res: AppConfig) => this.config$.next(res)));
  }

  public config() {
    return this.config$.asObservable();
  }
}
